import React, {Component} from 'react';
import {Page, Searchbar} from 'framework7-react';
import SearchResult from '../SearchResult';

/// Displays a searchable list of buildings.
export default class Search extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            searchTerm: ''
        };
    }

    handleInput = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
        }

        let value = document.querySelector('#search input').value;
        this.setState(prevState => ({searchTerm: value}));
    };

    render() {
        return (
            <Page>
                <Searchbar id="search" onInput={this.handleInput}/>
                <div className="statusbar-overlay"></div>
                <SearchResult buildings={this.props.buildings} searchTerm={this.state.searchTerm}/>
            </Page>
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/pages/Search.jsx